import { useEffect, useState } from 'react';

import axiosPixLink from 'config/axiosPixLink';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import SuperAdminHistoricalBacklinkingsTableControl from 'components/Netlinking/Table/SuperAdmin/SuperAdminHistoricalBacklinkingsTableControl';
import SuperAdminSearchSpotTableControl from 'components/Netlinking/Table/SuperAdmin/SuperAdminSearchSpotTableControl';
import SuperAdminSelectedSpotTableControl from 'components/Netlinking/Table/SuperAdmin/SuperAdminSelectedSpotTableControl';
import { MyCustomHighchartsSmall } from 'components/shared/Charts/MyCustomHighChartsSmall';
import { MyCustomHighcharts } from 'components/shared/Charts/MyCustomHighcharts';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import ErrorSuccesModal from 'components/shared/modal/ErrorSuccesModal';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { COLOR_JAUGE, PIXLINK_CAMPAIGN_STATUS, PIXLINK_STATUS } from 'utils/Constants';
import { useHistoryState } from 'utils/hooks/useHistoryState';
import {
  calculateClientMinimumLinks,
  calculateMinimumLinks,
} from 'utils/netlinking/linksNumber';
import './order.css';
import ExcelUploaderSelection from 'components/shared/UploadExcel/UploadExcelSelection';
import UploadSpotModal from 'components/shared/modal/UploadSpotModal';

const API = {
  getAvailableThematics: '/netlinking/all-thematics',
  getAvailableLanguages: '/language/all',
  getExistingAccounts: 'website/account/all',
  getAllWriters: '/user/all',
  getAllWebsiteOfAccount: '/website',
  getAllDevisOfAccount: '/user/getDevise',
  updateCampaign: '/campaign/update',
  createSmartOrder: '/commands/addSmartCommand',
  getAllConsultants: '/user/consultants',
  getAllSuperConsultants: 'user/superconsultants',
  getCampaignDetail: '/campaign/campaignDetail/',
};

export default function SuperAdminCampaignSourcing({ campaignType, campaignStatus, handleNetlinkingData, handleTmpNetlinkingData, sendNewCampaignTarif }) {
  const dispatch = useDispatch();
  const [urlSearch, setUrlSearch] = useHistoryState('urlSearch', '');
  const { id } = useParams();
  const history = useHistory();
  const { t } = useTranslation();
  const [wantedNetlinkings, setWantedNetlinkings] = useState([]);
  const [historicBackLinkings, setHistoricBackLinkings] = useState([]);
  const [netlinkings, setNetlinkings] = useState([]);
  const [netlinkingsTmp, setNetlinkingsTmp] = useState([]);
  const [nbrOfLinksDemanded, setNbrOfLinksDemanded] = useState(0);
  const [wantedLinksFocus, setWantedLinksFocus] = useState(false);
  const [wantedLinksList, setWantedLinksList] = useState([]);
  const [wantedLinks, setWantedLinks] = useState('');
  const [nameSearch, setNameSearch] = useState('');
  const location = useLocation();
  const [netlinkingContactFilter, setNetlinkingContactFilter] = useState('');
  const [ordersPerPage, setOrdersPerPage] = useState(10);
  const [campaignFilter, setCampaignFilter] = useState(null);
  const [isSearchForNetlinkinngOpen, setIsSearchForNetlinkinngOpen] =
    useState(false);
  const [reactivateSelection, setReactivateSelection] = useState(false);
  const [errorSuccess, setErrorSuccess] = useState(false);
  const [errorSuccessMsg, setErrorSuccessMsg] = useState('');
  const [confirmationSaveForce, setConfirmationSaveForce] = useState(false);
  const [confirmationMsgSaveForce, setConfirmationMsgSaveForce] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [active, setActive] = useState(1);
  const [tmpReinform, setTmpReinform] = useState(false)
  const [modalAddSingleWanted, setModalAddSingleWanted] = useState(false);
  const [ancragePlanResult, setAncragePlanResult] = useState(null);
  const [checkedSpots, setCheckedSpots] = useState([]);

  const allCheckedAreBlue =
    checkedSpots.length > 0 &&
    checkedSpots.every(
      (item) => item.spotStatus === PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT
    );
  const navItems = [
    { text: t('Spots proposés'), active: 1 },
    { text: t('Spots sélectionnés'), active: 2 },
    { text: t('Historique Backlinks'), active: 3 },
  ];
  useEffect(() => {
    window.dispatchEvent(new Event('locationchange'));
    document.title = t('PixLink - Detail campaign');
  }, [t]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const win = searchParams.get("win");

    if (win == 2) {
      setActive(2);
    }
  }, [location.search]);
  useEffect(() => {
    axiosPixLink
      .get(
        API.getCampaignDetail +
        `${window.location.href.split('/')[
        window.location.href.split('/').length - 1
        ]
        }`
      )
      .then((res) => {
        setCampaignFilter(res.data);
        setWantedNetlinkings(res.data.wantedNetlinkings);
        setHistoricBackLinkings(res.data.historicBackLinkings);
        setNetlinkingsTmp(res.data.netlinkingSelecteds);
        handleTmpNetlinkingData(res.data.netlinkingSelecteds)
        setNetlinkings(res.data.netlinkingSelecteds);
        handleNetlinkingData(res.data.netlinkingSelecteds)
        setNbrOfLinksDemanded(res.data.linksNumbers);
      });
  }, []);

  function sendNetlinkingChoose(data) {
    const newData = data.map((item) => {
      if (!item.hasOwnProperty('netlinking')) {
        const newSchemaItem = {
          id: null,
          netlinking: {
            id: item?.id,
            domain: item?.domain,
            kwPositioned: item?.kwPositioned,
            trafic: item?.trafic,
            tF: item?.tF,
            cF: item?.cF,
            tarifHr: item?.tarifHr,
            conditions: item?.conditions,
            themesList: item?.themesList,
            topicsList: item?.topicsList,
            platformName: item?.platformName,
            platformPrice: item?.platformPrice,
            platformRC: item?.platformRC,
            platformHR: item?.platformHR,
            contactPhoneNumber: item?.contactPhoneNumber,
            languageId: item?.languageId,
            contact: item?.contact,
            tarifRc: item?.tarifRc,
            contactedTime: item?.contactedTime,
            type: item?.type
          },
          responsibleRedactio: null,

          responsiblePublication: null,
          programmationDate: null,
          publicationDate: null,
          contactDate: null,
          articleLink: null,
          spotLink: null,
          ancreLink: null,
          insertionLink: null,
          publicationStatus: null,
          redactionStatus: null,
          spotStatus: campaignStatus === PIXLINK_CAMPAIGN_STATUS.CAMPAIGN_STARTED_TO_BE_SELECTED_BY_CONSULTANT ? (campaignType ? PIXLINK_STATUS.TO_BE_VALIDATED_CLIENT : PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT) :
            campaignStatus === PIXLINK_CAMPAIGN_STATUS.CAMPAIGN_NOTIFIED_SUPER_CONSULTANT_TO_BE_APPROVED ? (campaignType ? PIXLINK_STATUS.TO_BE_VALIDATED_CLIENT : PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT) :
              campaignStatus === PIXLINK_CAMPAIGN_STATUS.CAMPAIGN_NOTIFIED_SUPER_ADMIN_TO_BE_APPROVED ? (campaignType ? PIXLINK_STATUS.TO_BE_VALIDATED_CLIENT : PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT) :
                campaignStatus === PIXLINK_CAMPAIGN_STATUS.CAMPAIGN_NOTIFIED_SUPER_ADMIN_SUPER_CONSULTANT_TO_BE_APPROVED ? (campaignType ? PIXLINK_STATUS.TO_BE_VALIDATED_CLIENT : PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT) :
                  campaignStatus === PIXLINK_CAMPAIGN_STATUS.CAMPAIGN_ANCRAGE_TO_BE_PREPARED ? PIXLINK_STATUS.TO_BE_COMMANDED :
                    campaignStatus === PIXLINK_CAMPAIGN_STATUS.CAMPAIGN_NOTIFIED_CONSULTANT_TO_BE_FILTERED ? PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT :
                      campaignStatus === PIXLINK_CAMPAIGN_STATUS.CAMPAIGN_NOTIFIED_CLIENT_TO_BE_VALIDATED ? (campaignType ? PIXLINK_STATUS.TO_BE_VALIDATED_CLIENT : PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT) : (campaignType ? PIXLINK_STATUS.TO_BE_VALIDATED_CLIENT : PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT),
        };
        return newSchemaItem;
      }

      return item;
    });

    setNetlinkingsTmp(newData);
    handleTmpNetlinkingData(newData)
    SaveNetlinkingToCampaignsSilent(newData);
  }
  const handleImportAncragePlan = (file) => {
    const formData = new FormData();
    formData.append('file', file);

    axiosPixLink
      .post(`/campaign/${id}/importAncragePlan`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => {
        setAncragePlanResult(res.data);
        if (res.data.notFound && res.data.notFound.length > 0) {
          setIsSuccess(false);
          setErrorSuccessMsg(
            `${res.data.updated} ${t('domaine(s) mis à jour')}.  ${t('Domaines non trouvés')} : ${res.data.notFound.join(', ')}`
          );
        } else {
          setIsSuccess(true);
          setErrorSuccessMsg(`${res.data.updated} ${t('domaine(s) mis à jour avec succès')} !`);
        }
        setErrorSuccess(true);
        axiosPixLink.get(API.getCampaignDetail + id).then((res2) => {
          setNetlinkings(res2.data.netlinkingSelecteds);
          handleNetlinkingData(res2.data.netlinkingSelecteds);
          setNetlinkingsTmp(res2.data.netlinkingSelecteds);
          handleTmpNetlinkingData(res2.data.netlinkingSelecteds);
        });
      })
      .catch((e) => {
        setIsSuccess(false);
        setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
        setErrorSuccess(true);
      });
  };
  const handleWantedLinksChange = (data) => {
    setWantedLinksList(data);
    axiosPixLink
      .post(`/campaign/addWantedNetlinkingFileSelection/${id}`, data)
      .then((res) => {
        const { rejectedDomains } = res.data?.body ?? {};

        if (rejectedDomains && rejectedDomains.length > 0) {
          setIsSuccess(false);
          setErrorSuccessMsg(
            `${rejectedDomains.length} domaine(s) rejeté(s) :\n` +
            rejectedDomains.map((d) => `• ${d}`).join('\n')
          );
        } else {
          setIsSuccess(true);
          setErrorSuccessMsg(`${t('Spot ajouté au favoris')} !`);
        }
        setErrorSuccess(true);

        axiosPixLink.get(API.getCampaignDetail + id).then((res2) => {
          setCampaignFilter(res2.data);
          setWantedNetlinkings(res2.data.wantedNetlinkings);
          setHistoricBackLinkings(res2.data.historicBackLinkings);
          setNetlinkingsTmp(res2.data.netlinkingSelecteds);
          handleTmpNetlinkingData(res2.data.netlinkingSelecteds);
          setNetlinkings(res2.data.netlinkingSelecteds);
          handleNetlinkingData(res2.data.netlinkingSelecteds);
          setNbrOfLinksDemanded(res2.data.linksNumbers);
        });
      })
      .catch((e) => {
        setIsSuccess(false);
        switch (e.response.status) {
          case 599:
            setErrorSuccessMsg('Attention le spot ajouté ' + e.response.data + ' semble être dupliqué');
            break;
          case 404:
            setErrorSuccessMsg(`${t("La campagne n'existe plus")}`);
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setErrorSuccess(true);
      });
  };

  const handleWantedLinksChangeSingle = (data) => {
    setWantedLinksList(data);
    axiosPixLink
      .post(
        `/campaign/addWantedNetlinkingFileSelection/${id}`,
        data
      )
      .then((res) => {
        setIsSuccess(true);
        setErrorSuccessMsg(
          `${t('Spot ajouté au favoris')} !`
        );
        setErrorSuccess(true);
        window.location.reload();
      })
      .catch((e) => {
        setIsSuccess(false);
        switch (e.response.status) {
          case 599:
            setErrorSuccessMsg('Attention le spot ajouté ' + e.response.data + ' semble être dupliqué');
            break;
          case 404:
            setErrorSuccessMsg(`${t("La campagne n'existe plus")}`);
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setErrorSuccess(true);
      });
  };

  function removeNetlinkingId(items) {
    const updatedNetlinkings = netlinkings.filter(
      (netlinking) =>
        !items.some((item) => item.netlinking.id === netlinking.netlinking.id)
    );
    updateSingleItemStatus(
      items.map((item) => {
        return { ...item, spotStatus: PIXLINK_STATUS.REFUSED_PIXALIONE };
      })
    );
  }

  const updateSingleItemStatus = async (updatedData) => {
    try {
      const response = await axiosPixLink.post(
        `/campaign/UpdateSingleSelectedClientMultipleNetlinkings/${id}`,
        updatedData
      );

      const idSet = updatedData.map((item) => item.netlinking.id);

      const newUpdatedData = netlinkings.map((item) => {
        if (idSet.includes(item.netlinking.id)) {
          return {
            ...item,
            spotStatus: PIXLINK_STATUS.REFUSED_PIXALIONE,
          };
        }
        return item;
      });
      setNetlinkingsTmp(newUpdatedData);
      handleTmpNetlinkingData(newUpdatedData)
      setNetlinkings(newUpdatedData);
      handleNetlinkingData(newUpdatedData)

      // Handle success, reset form if needed
    } catch (error) {
      console.error('Error:', error);
      // Handle error
    }
  };

  const RemoveNetlinkingToCampaigns = (netlinkingswithoutSpot) => {
    axiosPixLink
      .post(
        `/campaign/AddSelectedNetlinking/${id}`,
        netlinkingswithoutSpot.map((object) => ({
          ...object,
          publicationStatus:
            object.publicationStatus === '' ? null : object.publicationStatus,
          redactionStatus:
            object.redactionStatus === '' ? null : object.redactionStatus,
        }))
      )
      .then((res) => {
        setIsSuccess(true);
        setNetlinkings(netlinkingswithoutSpot);
        handleNetlinkingData(netlinkingswithoutSpot);
        sendNewCampaignTarif();
        setErrorSuccessMsg(
          `${t('Les spots')} ${t('ont été supprimés avec succès')} !`
        );
        setErrorSuccess(true);
      })
      .catch((e) => {
        setIsSuccess(false);
        switch (e.response.status) {
          case 404:
            setErrorSuccessMsg(`${t("La campagne n'existe plus")}`);
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setErrorSuccess(true);
      });
  };
  const ValiderAncrage = () => {
    axiosPixLink
      .post(`/campaign/validerAncrage/${id}`)
      .then((res) => {
        setIsSuccess(true);
        setErrorSuccessMsg(t("L'ancrage a été validé avec succès !"));
        setErrorSuccess(true);

      })
      .catch((e) => {
        setIsSuccess(false);
        setErrorSuccessMsg(t("Erreur lors de la validation de l'ancrage"));
        setErrorSuccess(true);
      });
  };
  const sendUpdateSaveSelectedNetlinking = (updatedData) => {
    setNetlinkingsTmp(updatedData);
    handleTmpNetlinkingData(updatedData)
    setNetlinkings(updatedData);
    handleNetlinkingData(updatedData)
  };

  const SaveNetlinkingToCampaignsSilent = (netlinkingsTmp) => {
    setNetlinkings(netlinkingsTmp);
    handleNetlinkingData(netlinkingsTmp)
    axiosPixLink
      .post(
        `/campaign/AddSelectedNetlinking/${id}`,
        netlinkingsTmp.map((object) => ({
          ...object,
          publicationStatus:
            object.publicationStatus === '' ? null : object.publicationStatus,
          redactionStatus:
            object.redactionStatus === '' ? null : object.redactionStatus,
        }))
      )
      .then((res) => {
        setNetlinkings(netlinkingsTmp);
        handleNetlinkingData(netlinkingsTmp)
      })
      .catch((e) => { });
  };

  const SaveNetlinkingToCampaigns = () => {
    setReactivateSelection(false)
    setConfirmationSaveForce(false);
    setNetlinkings(netlinkingsTmp);
    handleNetlinkingData(netlinkingsTmp)
    sendNewCampaignTarif();
    axiosPixLink
      .post(
        `/campaign/AddSelectedNetlinking/${id}`,
        netlinkingsTmp.map((object) => ({
          ...object,
          publicationStatus:
            object.publicationStatus === '' ? null : object.publicationStatus,
          redactionStatus:
            object.redactionStatus === '' ? null : object.redactionStatus,
        }))
      )
      .then((res) => {
        setIsSuccess(true);
        setNetlinkings(netlinkingsTmp);
        handleNetlinkingData(netlinkingsTmp)
        sendNewCampaignTarif();
        setErrorSuccessMsg(
          `${t('Les spots')} ${t('ont été ajoutés avec succes')} !`
        );
        setErrorSuccess(true);
      })
      .catch((e) => {
        setIsSuccess(false);
        switch (e.response.status) {
          case 404:
            setErrorSuccessMsg(`${t("La campagne n'existe plus")}`);
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setErrorSuccess(true);
      });
  };

  function haveSharedDomain(array1, array2) {
    // Extract domains from array1
    const domains1 = array1.map((obj) => obj?.netlinking?.domain);

    // Iterate over array2 and check if any domain matches
    for (let i = 0; i < array2.length; i++) {
      if (domains1.includes(array2[i]?.domain)) {
        return true; // If match found, return true
      }
    }

    return false; // If no match found, return false
  }

  const GlobalSaveNetlinkingToCampaigns = () => {
    if (haveSharedDomain(netlinkings, historicBackLinkings)) {
      setConfirmationMsgSaveForce(
        "Attention, vous allez ajouter un domaine qui existe dans la liste d'historique backlinks. Êtes-vous sûre de vouloir continuer ?"
      );
      setConfirmationSaveForce(true);
    } else {
      setConfirmationMsgSaveForce(
        t('Étes-vous sûre de vouloir valider la sélection des spots ? ')
      );
      setConfirmationSaveForce(true);
    }
  };

  const NotifierSuperConsultantNetlinkingToCampaigns = () => {
    axiosPixLink
      .post(
        `/campaign/NotifySuperConsultantFromSuperAdminSelectedNetlinking/${id}`,
        netlinkings.map((object) => ({
          ...object,
          publicationStatus:
            object.publicationStatus === '' ? null : object.publicationStatus,
          redactionStatus:
            object.redactionStatus === '' ? null : object.redactionStatus,
        }))
      )
      .then((res) => {
        setIsSuccess(true);
        const newNetlinkings = netlinkings.map((item) => {
          if (item.spotStatus === PIXLINK_STATUS.REFUSED_PIXALIONE) {
            return {
              ...item,
              spotStatus: PIXLINK_STATUS.REFUSED_PIXALIONE,
              responsibleRedaction: null,
              responsiblePublication: null,
              programmationDate: null,
              publicationDate: null,
              contactDate: null,
              articleLink: null,
              spotLink: null,
              ancreLink: null,
              insertionLink: null,
              publicationStatus: null,
              redactionStatus: null
            };
          } else if (item.spotStatus === PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT) {
            return {
              ...item,
              spotStatus: PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT,
              responsibleRedaction: null,
              responsiblePublication: null,
              programmationDate: null,
              publicationDate: null,
              contactDate: null,
              articleLink: null,
              spotLink: null,
              ancreLink: null,
              insertionLink: null,
              publicationStatus: null,
              redactionStatus: null
            };
          } else {
            return {
              ...item,
              spotStatus: PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT,
              responsibleRedaction: null,
              responsiblePublication: null,
              programmationDate: null,
              publicationDate: null,
              contactDate: null,
              articleLink: null,
              spotLink: null,
              ancreLink: null,
              insertionLink: null,
              publicationStatus: null,
              redactionStatus: null
            };
          }
        })
        if (!campaignType) {
          setNetlinkings(newNetlinkings)
          handleNetlinkingData(newNetlinkings)

        } else {
          const newNetlinkings = netlinkings.map((item) => {
            if (item.spotStatus === PIXLINK_STATUS.REFUSED_PIXALIONE) {
              return {
                ...item,
                spotStatus: PIXLINK_STATUS.REFUSED_PIXALIONE,
                responsibleRedaction: null,
                responsiblePublication: null,
                programmationDate: null,
                publicationDate: null,
                contactDate: null,
                articleLink: null,
                spotLink: null,
                ancreLink: null,
                insertionLink: null,
                publicationStatus: null,
                redactionStatus: null
              };
            } else if (item.spotStatus === PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT) {
              return {
                ...item,
                spotStatus: PIXLINK_STATUS.TO_BE_FILTERED_CONSULTANT,
                responsibleRedaction: null,
                responsiblePublication: null,
                programmationDate: null,
                publicationDate: null,
                contactDate: null,
                articleLink: null,
                spotLink: null,
                ancreLink: null,
                insertionLink: null,
                publicationStatus: null,
                redactionStatus: null
              };
            } else {
              return {
                ...item,
                spotStatus: PIXLINK_STATUS.TO_BE_VALIDATED_CLIENT,
                responsibleRedaction: null,
                responsiblePublication: null,
                programmationDate: null,
                publicationDate: null,
                contactDate: null,
                articleLink: null,
                spotLink: null,
                ancreLink: null,
                insertionLink: null,
                publicationStatus: null,
                redactionStatus: null
              };
            }
          })
          setNetlinkings(newNetlinkings);
          handleNetlinkingData(newNetlinkings)
        }
        setErrorSuccessMsg(
          `${t('Super Consultant')} ${t('a été notifié avec succès')} !`
        );

        setTmpReinform(true)
        setErrorSuccess(true);
      })
      .catch((e) => {
        setIsSuccess(false);
        switch (e.response.status) {
          case 404:
            setErrorSuccessMsg(`${t("La campagne n'existe plus")}`);
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setErrorSuccess(true);
      });
  };

  const NotifierSuperConsultntReinform = () => {
    axiosPixLink
      .post(
        `/campaign/NotifySuperConsultantSelectedNetlinkingReinform/${id}`,
        netlinkings
          .map((object) => ({
            ...object,
            publicationStatus:
              object.publicationStatus === '' ? null : object.publicationStatus,
            redactionStatus:
              object.redactionStatus === '' ? null : object.redactionStatus,
          }))
          .filter(
            (item) =>
              item.spotTmpStatus !== PIXLINK_STATUS.NOT_FILTERED_CONSULTANT
          )
      )
      .then((res) => {
        setIsSuccess(true);
        setErrorSuccessMsg(
          campaignType
            ? `${t('Super Consultant')} ${t('a été renotifié avec succès')} !`
            : `${t('Super Consultant')} ${t('a été renotifié avec succès')} !`
        );
        setErrorSuccess(true);
      })
      .catch((e) => {
        setIsSuccess(false);
        switch (e.response.status) {
          case 404:
            setErrorSuccessMsg(`${t("La campagne n'existe plus")}`);
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setErrorSuccess(true);
      });
  };

  const NotifierSuperAdminFilteringNetlinkingToCampaigns = () => {
    axiosPixLink
      .post(
        `/campaign/NotifySuperAdminFilteredSelectedNetlinking/${id}`,
        checkedSpots.map((object) => ({
          ...object,
          publicationStatus:
            object.publicationStatus === '' ? null : object.publicationStatus,
          redactionStatus:
            object.redactionStatus === '' ? null : object.redactionStatus,
        }))
      )
      .then((res) => {
        setIsSuccess(true);
        setNetlinkings((prevNetlinkings) => {
          const newData = prevNetlinkings.map((item) => {
            const isChecked = checkedSpots.some(
              (checked) => checked.netlinking.id === item.netlinking.id
            );
            if (isChecked) {
              return { ...item, spotStatus: PIXLINK_STATUS.TO_BE_COMMANDED };
            }
            return item;
          });
          handleNetlinkingData(newData);
          setNetlinkingsTmp(newData);
          handleTmpNetlinkingData(newData);
          return newData;
        });
        setCheckedSpots([]);
        setErrorSuccessMsg(
          `${t('Les spots cochés ont été passés à commander avec succès')} !`
        );
        setErrorSuccess(true);
      })
      .catch((e) => {
        setIsSuccess(false);
        switch (e.response.status) {
          case 404:
            setErrorSuccessMsg(`${t("La campagne n'existe plus")}`);
            break;
          default:
            setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
            break;
        }
        setErrorSuccess(true);
      });
  };
  return (
    <div>
      <div className="content-center">
        <div className="col-12 col-md-8 mb-2">
          <ul className="nav nav-tabs nav-tabs-ct">
            {navItems.map((item, index) => (
              <li key={index} className="nav-item">
                <button
                  onClick={() => {
                    setActive(item.active);
                  }}
                  className={`nav-link ${item.active === active ? 'active' : ''
                    }`}
                  data-bs-toggle="tab"
                  type="button"
                  role="tab"
                >
                  {item.text}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="row-homePage">
          {active === 1 && (
            <div
              className="col-12 col-md-12 mr-3"
              style={{ marginRight: '5px' }}
            >
              <div className="box-wrapper">
                {campaignFilter && (
                  <SuperAdminSearchSpotTableControl
                    sendNetlinkingChoose={sendNetlinkingChoose}
                    netlinikingToChoseData={netlinkingsTmp}
                    netlinkingChosenData={netlinkings}
                    campaignType={campaignType}
                    campaignFilter={campaignFilter}
                    wantedNetlinkings={wantedNetlinkings}
                    historicBackLinkings={historicBackLinkings}
                    campaignStatus={campaignStatus}
                    reactivateSelection={reactivateSelection}
                  ></SuperAdminSearchSpotTableControl>
                )}
                <div style={{ marginBottom: '25px' }}></div>
              </div>
            </div>
          )}
          {active === 2 && (
            <div
              className="col-12 col-md-12 mr-3"
              style={{ marginRight: '5px' }}
            >
              <div className="box-wrapper">
                <div className="box-list-header"></div>
                <SuperAdminSelectedSpotTableControl
                  netlinkings={netlinkings.filter(
                    (item) =>
                      item.spotStatus !== PIXLINK_STATUS.REFUSED_PIXALIONE
                  )}
                  campaignFilter={null}
                  wantedNetlinkings={wantedNetlinkings}
                  historicBackLinkings={historicBackLinkings}
                  removeNetlinkingId={removeNetlinkingId}
                  SaveNetlinkingToCampaigns={SaveNetlinkingToCampaigns}
                  sendUpdateSaveSelectedNetlinking={
                    sendUpdateSaveSelectedNetlinking
                  }
                  campaignStatus={campaignStatus}
                  campaignType={campaignType}
                  sendNewCampaignTarif={sendNewCampaignTarif}
                  sendCheckedItems={(items) => setCheckedSpots(items)}
                ></SuperAdminSelectedSpotTableControl>

                <div style={{ marginBottom: '25px' }}></div>
              </div>
            </div>
          )}
          {active === 3 && (
            <div
              className="col-12 col-md-12 mr-3"
              style={{ marginRight: '5px' }}
            >
              <div className="box-wrapper">
                <div className="box-list-header"></div>
                <SuperAdminHistoricalBacklinkingsTableControl
                  historicBackLinkings={historicBackLinkings}
                  campaignFilter={null}
                  wantedNetlinkings={wantedNetlinkings}
                  removeNetlinkingId={removeNetlinkingId}
                  SaveNetlinkingToCampaigns={SaveNetlinkingToCampaigns}
                ></SuperAdminHistoricalBacklinkingsTableControl>
                <div style={{ marginBottom: '25px' }}></div>
              </div>
            </div>
          )}
        </div>
        {active === 1 && (
          <span>
            <button
              className="bt-submit-y"
              style={{
                margin: '0 auto',
                marginTop: '5px',
                marginLeft: '5px',
                alignSelf: 'right',
                float: 'right',
              }}
              onClick={GlobalSaveNetlinkingToCampaigns}
            >
              {t('Valider')}
            </button>

            {(campaignStatus === PIXLINK_CAMPAIGN_STATUS.CAMPAIGN_ANCRAGE_TO_BE_PREPARED ||
              campaignStatus === PIXLINK_CAMPAIGN_STATUS.CAMPAIGN_NOTIFIED_CLIENT_TO_BE_VALIDATED ||
              campaignStatus === PIXLINK_CAMPAIGN_STATUS.CAMPAIGN_NOTIFIED_SUPER_CONSULTANT_TO_BE_APPROVED ||
              campaignStatus === PIXLINK_CAMPAIGN_STATUS.CAMPAIGN_NOTIFIED_CONSULTANT_TO_BE_FILTERED
            ) && (<button
              className={reactivateSelection ? "bt-submit-disabled-y" : "bt-submit-y"}
              disabled={reactivateSelection}
              style={{
                margin: '0 auto',
                marginTop: '5px',
                marginLeft: '5px',
                alignSelf: 'right',
                float: 'right',
              }}
              onClick={() => setReactivateSelection(true)}
            >
              {t('Reactiver Selection')}
            </button>)}
          </span>
        )}
        {active === 2 && (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px', width: '100%' }}>

            {/* LEFT GROUP */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <label className="bt-submit-y" style={{ cursor: 'pointer', margin: 0 }}>
                {t("Importer un plan d'ancrage")}
                <input
                  type="file"
                  accept=".xls,.xlsx"
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    if (e.target.files && e.target.files[0]) {
                      handleImportAncragePlan(e.target.files[0]);
                      e.target.value = '';
                    }
                  }}
                />
              </label>
              <button className="bt-submit-y" style={{ margin: 0 }} onClick={() => setModalAddSingleWanted(true)}>
                {t('Ajouter Spot')}
              </button>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: '-46px' }}>
                <ExcelUploaderSelection
                  handleLinksChange={handleWantedLinksChange}
                  sendFileName={(name) => setWantedLinks(name)}
                  type="wantedLinks"
                />
              </div>
            </div>

            {/* RIGHT GROUP */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {allCheckedAreBlue ? (
                <button
                  className="bt-submit-y"
                  style={{ margin: 0 }}
                  onClick={NotifierSuperAdminFilteringNetlinkingToCampaigns}
                >
                  {t('Prêt à lancer')}
                </button>
              ) : (
                <button
                  className="bt-submit-disabled-y"
                  style={{ margin: 0 }}
                  disabled
                >
                  {t('Prêt à lancer')}
                </button>
              )}
              {campaignStatus === PIXLINK_CAMPAIGN_STATUS.CAMPAIGN_ANCRAGE_TO_BE_PREPARED && (
                <button className="bt-submit-y" style={{ margin: 0 }} onClick={ValiderAncrage}>
                  {t("Valider l'ancrage")}
                </button>
              )}
              {!tmpReinform && (!campaignStatus ||
                campaignStatus === PIXLINK_CAMPAIGN_STATUS.CAMPAIGN_STARTED_TO_BE_SELECTED_BY_CONSULTANT ||
                campaignStatus === PIXLINK_CAMPAIGN_STATUS.CAMPAIGN_NOTIFIED_SUPER_ADMIN_SUPER_CONSULTANT_TO_BE_APPROVED ||
                campaignStatus === PIXLINK_CAMPAIGN_STATUS.CAMPAIGN_NOTIFIED_SUPER_ADMIN_TO_BE_APPROVED) ? (
                <button className="bt-submit-y" style={{ margin: 0 }} onClick={NotifierSuperConsultantNetlinkingToCampaigns}>
                  {t('Informer super consultant')}
                </button>
              ) : (
                <button className="bt-submit-y" style={{ margin: 0 }} onClick={NotifierSuperConsultntReinform}>
                  {t('Reinformer super consultant')}
                </button>
              )}
            </div>

          </div>
        )}
      </div>

      <ErrorSuccesModal
        open={errorSuccess}
        message={errorSuccessMsg}
        handleClose={() => {
          setErrorSuccess(false);
          //       history.goBack();
        }}
        success={isSuccess}
      />
      <ConfirmationModal
        open={confirmationSaveForce}
        message={confirmationMsgSaveForce}
        handleClose={() => setConfirmationSaveForce(false)}
        executeAction={SaveNetlinkingToCampaigns}
      />
      <UploadSpotModal
        open={modalAddSingleWanted}
        handleClose={() => { setModalAddSingleWanted(false) }}
        executeAction={handleWantedLinksChangeSingle}
      />
    </div >
  );
}
